import {
  ButtonGroup,
  ButtonGroupColorEnum,
  CategoryListIcon,
  FiltersCloseEyeIcon,
  FiltersOpenEyeIcon,
  PlayIsolatedIcon,
  SummaryEditIcon,
  Tooltip,
  TooltipPositionsEnum,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { I18nextTranslationKeys } from '@/i18n/i18next';
import { TValueToLabels } from '@/types';

import { ESegmentToolkit } from '../../BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/types';

export function BroadcastScheduleProgramHeaderCardList() {
  const {
    visibleBroadcastProgramCards,
    totalActiveCards,
    activeSegment,
    pinnedId,
    activeClip,
    setVisibleBroadcastProgramCards,
    setIsHeaderVisible,
    handleTooltikClick,
  } = useBroadcastScheduleProgram();
  const { t } = useTranslation();
  const cards = Object.entries(visibleBroadcastProgramCards || {});

  const valueToLabels: TValueToLabels = {
    segments: {
      label: t('Lista'),
      tooltipHidden: t('Mostrar lista') as I18nextTranslationKeys,
      tooltipVisible: t('Ocultar lista') as I18nextTranslationKeys,
      icon: <CategoryListIcon />,
      onClick: () => {
        setVisibleBroadcastProgramCards(prev => {
          return {
            ...prev,
            segments: !prev.segments,
          };
        });
      },
    },
    segmentDetail: {
      label: t('Detalle'),
      tooltipHidden: t('Mostrar detalle') as I18nextTranslationKeys,
      tooltipVisible: t('Ocultar detalle') as I18nextTranslationKeys,
      icon: <PlayIsolatedIcon />,
      onClick: () => {
        setVisibleBroadcastProgramCards(prev => {
          return {
            ...prev,
            segmentDetail: !prev.segmentDetail,
          };
        });
      },
    },
    segmentToolkit: {
      label: t('Herramientas'),
      tooltipHidden: t('Mostrar herramientas') as I18nextTranslationKeys,
      tooltipVisible: t('Ocultar herramientas') as I18nextTranslationKeys,
      icon: <SummaryEditIcon />,
      onClick: () => {
        setVisibleBroadcastProgramCards(prev => {
          if (!prev.segmentToolkit && !pinnedId && !activeClip)
            handleTooltikClick(ESegmentToolkit.CORTES);
          return {
            ...prev,
            segmentToolkit: !prev.segmentToolkit,
          };
        });
      },
    },
    filters: {
      label: t('Filtros'),
      tooltipHidden: t('Mostrar filtros') as I18nextTranslationKeys,
      tooltipVisible: t('Ocultar filtros') as I18nextTranslationKeys,
      icon: !visibleBroadcastProgramCards?.filters ? (
        <FiltersOpenEyeIcon />
      ) : (
        <FiltersCloseEyeIcon />
      ),
      onClick: () => {
        setIsHeaderVisible(prev => !prev);
        setVisibleBroadcastProgramCards(prev => {
          return {
            ...prev,
            filters: !prev.filters,
          };
        });
      },
    },
  };

  return (
    <div className="flex items-center gap-2" id="segments-column-filters">
      {cards.map(([card, isVisible]) => (
        <Tooltip
          position={TooltipPositionsEnum.LEFT}
          key={card}
          help={
            isVisible
              ? t(valueToLabels[card]?.tooltipVisible)
              : t(valueToLabels[card]?.tooltipHidden)
          }
          grow
        >
          <ButtonGroup
            color={ButtonGroupColorEnum.DEFAULT_GHOST}
            className={clsx(
              'rounded-full border-none p-size-6 outline-none',
              isVisible && 'bg-black/[.05]',
              totalActiveCards === 1 && isVisible && 'cursor-not-allowed'
            )}
            disabled={
              (totalActiveCards === 1 && isVisible) ||
              ((card === 'segmentDetail' || card === 'segmentToolkit') &&
                !activeSegment &&
                !activeClip)
            }
            onClick={valueToLabels[card]?.onClick}
          >
            {valueToLabels[card]?.icon}
          </ButtonGroup>
        </Tooltip>
      ))}
    </div>
  );
}
